<template>
  <div id="app" class="h-100">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import { getCookie, setHoursCookie } from '@/utils/auth'
import { versionKontrol } from '@/api/version'
import { routePost } from '@/api/yol'

export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Yaz Okulu'
  },
  watch: {
    async $route (n, o) {
      if (o && getCookie('token')) {
        try {
          await routePost(window.location.href)
        } catch (e) {
          console.error(e)
        }
      }
    }
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  async created () {
    await this.apidenversionKontrol()
  },
  methods: {
    async apidenversionKontrol () {
      try {
        const result = await versionKontrol()
        console.log('API Front-End Version', result.version)
        const localVersion = getCookie('frontend-version')
        console.log('Local Front-End Version', localVersion)
        if (!localVersion) {
          setHoursCookie('frontend-version', result.version, 8760)
          location.reload()
        }
        if (result.version !== localVersion) {
          setHoursCookie('frontend-version', result.version, 8760)
          location.reload()
        }
        console.log('Time', new Date())
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
<style>
.toast-body {
  white-space: pre-line !important;
}

.bv-no-focus-ring {
  width: 100%;
}
</style>
